import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'WeployDesignLanguage/Dialog';
import Button from 'WeployDesignLanguage/buttons/Button';
import { StyledDialogTitleSubtitle } from './style';

const EditRoleDialog = ({
  confirmAction,
  content,
  onClose,
  open,
}) => (
  <Dialog onClose={onClose} open={open}>
    <Dialog.Title onClose={onClose}>
      Edit role
      <StyledDialogTitleSubtitle>Choose and assign a role with permissions that best suit the user</StyledDialogTitleSubtitle>
    </Dialog.Title>
    <Dialog.Content>{content}</Dialog.Content>
    <Dialog.Actions>
      <Button
        appearance={Button.TEXT}
        onClick={onClose}
      >
        Cancel
      </Button>
      {confirmAction}
    </Dialog.Actions>
  </Dialog>
);

EditRoleDialog.propTypes = {
  confirmAction: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

EditRoleDialog.defaultProps = {
  confirmAction: null,
  content: null,
};

export default EditRoleDialog;
